import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';

export default function ForbiddenPage() {
	const navigate = useNavigate();

	return (
		<div className="flex items-center justify-center min-h-screen bg-gray-50">
			<Result
				status="403"
				title="403"
				subTitle="Sorry, you don't have permission to access this page."
				extra={[
					<Button key="back" onClick={() => navigate(-1)}>
						Go Back
					</Button>,
					<Button key="home" type="primary" onClick={() => navigate('/')}>
						Go Home
					</Button>,
				]}
			/>
		</div>
	);
}
